import { Box } from '@mui/material';
import { Flag as FlagIcon } from '@mui/icons-material';
import { TextSpan } from '../../../Atoms/Text';
import { FeatureStateLabel } from './FeatureStateLabel';

// The flag is UPSTACK's own, so its line shows only to those who can clear one.
export const FeatureResponsesLegend = ({ showFlag }: { showFlag: boolean }) => (
  <Box className="flex flex-col gap-1 rounded-lg bg-grey-1 p-3">
    <TextSpan
      size="xs"
      weight="semibold"
      color="grey6">
      RESPONSE STATE LEGEND
    </TextSpan>
    <Box className="flex flex-wrap gap-x-6 gap-y-1">
      {(
        [
          ['supported', 'vendor confirms native support'],
          ['partial', 'requires a vendor note'],
          ['not_supported', 'vendor answered no'],
          [null, 'not yet imported']
        ] as const
      ).map(([state, meaning]) => (
        <TextSpan
          key={state ?? 'awaiting'}
          size="xs"
          color="grey6">
          <FeatureStateLabel state={state} /> — {meaning}
        </TextSpan>
      ))}
    </Box>
    {showFlag && (
      <TextSpan
        size="xs"
        color="grey6">
        <FlagIcon
          sx={{ fontSize: 14, verticalAlign: 'text-bottom' }}
          color="warning"
          aria-hidden="true"
        />{' '}
        UPSTACK-only flag: disputes a supplier&apos;s answer until it is reviewed; the client sees that feature as
        awaiting meanwhile.
      </TextSpan>
    )}
  </Box>
);
